module.exports = __webpack_public_path__ + "static/media/Picture4-300x225x250.8f135990.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/Picture4-300x225x250.png
// module id = 107
// module chunks = 0